<template>
  <div class="p-none">
    <ItemsTable :items="items" :total="total" :loading="loading" class="mt-1" />
    <Pagination class="mt-1" :total="total" :page="page" @pagination="update" />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted } from 'vue'
import ItemsTable from './RetargetingListTab/ItemsTable.vue'

import { useRetargetingListsStore } from '@/apps/traforama/store/retargetingLists'
import Pagination from '@/components/Pagination.vue'
import useResize from '@/hooks/useResize'

export default defineComponent({
  name: 'RetargetingListsTab',
  components: {
    ItemsTable,
    Pagination
  },
  props: {},
  setup(props, context) {
    const retargetingListsStore = useRetargetingListsStore()

    const total = computed(() => retargetingListsStore.total)
    const items = computed(() => retargetingListsStore.currentItems)
    const page = computed(() => retargetingListsStore.currentPage)
    const loading = computed(() => retargetingListsStore.listLoading)

    const { isDesktop } = useResize()

    const update = ({
      limit = 15,
      newPage = 1
    }: {
      limit?: number
      newPage?: number
    }) => {
      retargetingListsStore.SetCurrentPage(newPage)
      retargetingListsStore.FetchItems()
    }

    onMounted(() => {
      update({})
    })

    return {
      loading,
      page,
      update,
      items,
      total,
      isDesktop
    }
  }
})
</script>
